module.exports = {
      id: "hamburger-facebook-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#hamburger-facebook",
      toString: function () {
        return this.url;
      }
    }